export const escapeGameUid = (gameUid: string) => {
  const matchedUid = () => {
    const matches = gameUid.match(/^[^?&]+/g);
    if (!matches) {
      return gameUid;
    }

    return matches[0];
  };

  return gameUid && gameUid !== 'undefined' ? matchedUid() : undefined;
};
